import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getColor, sizes } from 'src/styles'
import { mergeProps } from 'src/util'
import Loader from '../Loader'
import styles from './Icon.scss'

/**
 * An svg icon.
 */
const Icon = ({ icon, size, color, children, loading, ...domProps }) => {
  const Component = loading
    ? Loader
    : children
    ? ({ fixedWidth, ...props }) => <span {...mergeProps()({ style: { fontSize: '1em' } }, props)}>{children}</span>
    : typeof icon === 'string'
    ? // eslint-disable-next-line react/display-name
      props => <FontAwesomeIcon {...props} icon={icon} />
    : icon

  return (
    <Component
      {...mergeProps()(
        {
          className: [styles.icon, styles[size]],
          style: { color: domProps.inverse ? undefined : getColor(color) },
        },
        domProps
      )}
    />
  )
}

Icon.defaultProps = {
  size: 'md',
  color: 'inherit',
}

Icon.propTypes = {
  icon: PropTypes.elementType,
  /**
   * The icon size.
   */
  size: PropTypes.oneOf(['inherit', ...sizes]),
  /**
   * The icon color.
   */
  color: PropTypes.string,
  /**
   * Whether the icon is in loading state or not
   */
  loading: PropTypes.bool,
  /**
   * When children are provided, they are used as the icon
   */
  children: PropTypes.node,
}

export default React.memo(Icon)
